// extracted by mini-css-extract-plugin
module.exports = {"container":"token-history_container__1T5QE","btn":"token-history_btn__5T8Nf","price":"token-history_price__3QzWP","day":"token-history_day__UD7mG"};